import { combineReducers, configureStore } from '@reduxjs/toolkit';
import yearReducer from './reducers/YearSlice';
import yearSReducer from './reducers/SYearSlice';
import wsReducer from './reducers/WsSlice';
import authReducer from './reducers/AuthSlice';
import userInfoReducer from './reducers/UserInfoSlice';
import langReducer from './reducers/LangSlice';
import isAdmissionReducer from './reducers/IsReportAdmission';
import isJournalReducer from './reducers/IsReportJournal';
import checkPayReducer from './reducers/CheckPaySlice';
import JuOrJuReducer from './reducers/JuOrJuSlice';
import PermissReducer from './reducers/PermSlice';
import errorModalReducer from './reducers/requestErrModalSlice';
import controlPermReducer from './reducers/ControlPermSlice';
const rootReducer = combineReducers({
    userInfoReducer,
    authReducer,
    yearReducer,
    yearSReducer,
    wsReducer,
    langReducer,
    isAdmissionReducer,
    isJournalReducer,
    checkPayReducer,
    JuOrJuReducer,
    PermissReducer,
    errorModalReducer,
    controlPermReducer
});
const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        devTools: process.env.NODE_ENV == 'development'
    });
};
export const store = setupStore();
